import { render, staticRenderFns } from "./BookingMenu.vue?vue&type=template&id=aaa7c8dc&scoped=true&lang=pug"
import script from "./BookingMenu.vue?vue&type=script&lang=js"
export * from "./BookingMenu.vue?vue&type=script&lang=js"
import style0 from "./BookingMenu.vue?vue&type=style&index=0&id=aaa7c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa7c8dc",
  null
  
)

export default component.exports